import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

const STEPS = [["en_produccion", "En producción"], ["enviado", "Enviado"], ["entregado", "Entregado"]];

export const OrderStatus = ({ o, refetch }) => {
  const [st, setSt] = useState(o.status);
  const [carrier, setCarrier] = useState(o.carrier || "");
  const [tracking, setTracking] = useState(o.tracking || "");
  const [busy, setBusy] = useState(false);
  const last = (o.status_history || []).at(-1);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/orders/${o.id}/status`, { status: st, carrier, tracking });
      const mail = data.status_history?.at(-1)?.email;
      mail?.status === "sent" ? toast.success("Estado guardado y correo enviado al cliente") : toast.error(`Estado guardado, pero el correo falló: ${mail?.error || "error"}`);
      refetch();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div data-testid={`order-${o.number}-status`} className="mt-4 border-t border-[#1C1715]/10 pt-4">
      <div className="flex flex-wrap items-center gap-2">
        {STEPS.map(([k, label]) => (
          <button key={k} type="button" data-testid={`order-${o.number}-status-${k}`} onClick={() => setSt(k)}
            className={`rounded-full px-4 py-1.5 text-xs transition-colors ${st === k ? "bg-[#1C1715] text-white" : "border border-[#1C1715]/20 hover:border-[#1C1715]"}`}>{label}</button>
        ))}
      </div>
      {st === "enviado" && (
        <div className="mt-3 grid gap-3 sm:grid-cols-2">
          <Input data-testid={`order-${o.number}-carrier`} placeholder="Transportadora (ej. Servientrega)" value={carrier} onChange={(e) => setCarrier(e.target.value)} />
          <Input data-testid={`order-${o.number}-tracking`} placeholder="Número de guía" value={tracking} onChange={(e) => setTracking(e.target.value)} />
        </div>
      )}
      <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-[#5C534C]">
        <button type="button" data-testid={`order-${o.number}-status-save`} disabled={busy || (st === o.status && st !== "enviado")} onClick={save}
          className="rounded-full bg-[#B18A4B] px-4 py-1.5 font-semibold text-white transition-colors hover:bg-[#1C1715] disabled:opacity-40">{busy ? "Guardando…" : "Guardar y avisar al cliente"}</button>
        {last && <span data-testid={`order-${o.number}-status-last`}>Último aviso: {STEPS.find(([k]) => k === last.status)?.[1]} · {new Date(last.at).toLocaleString("es-CO")}{last.email ? ` · correo ${last.email.status === "sent" ? "enviado" : "con error"}` : ""}</span>}
      </div>
    </div>
  );
};
